import { CardWrapper } from '@mosey/components/layout/CardWrapper';
import { TaskSummaryCard } from '@mosey/components/layout/Card';
import { TruncatedList } from '@mosey/components/layout/TruncatedList';
import { ZeroState } from '@mosey/components/layout/ZeroState';
import { useLocationId } from '@mosey/components/hooks/navigation';
import { useTasksOverviewData } from '../../utils/hooks';
import zeroStateGraphic from '../../../../assets/tasks-framework/tasks-overview-sidebar-automated-zero.svg';
import { ResolverType } from '../../utils/types';
import { generateResolverTasksBrowserUrl } from '../../utils';
import { ModuleHeading } from './ModuleHeading';

export const InProgressCollection = () => {
  const { inProgress } = useTasksOverviewData();
  const locationId = useLocationId();

  return (
    <TruncatedList
      title={<ModuleHeading>Automations in Progress</ModuleHeading>}
      itemLabel="automations"
      isStacked
      as="nav"
      aria-live="polite"
    >
      {inProgress.length === 0 && (
        <ZeroState
          variant="row"
          graphic={
            <img
              src={zeroStateGraphic}
              alt=""
              className="h-full object-contain"
            />
          }
          title="You have no automations in progress."
        />
      )}

      {...inProgress.map(({ id, title, status }) => {
        return (
          <CardWrapper key={id} as="li">
            <TaskSummaryCard
              title={title}
              status={status === 'deferred' ? 'todo' : status}
              variant="nav"
              size="medium"
              to={generateResolverTasksBrowserUrl({
                locationId,
                resolverType: ResolverType.InProgress,
                taskId: id,
              })}
            />
          </CardWrapper>
        );
      })}
    </TruncatedList>
  );
};
